import React, { useEffect, useState } from 'react';
import { Button, Form, Spinner, Row, Col } from 'react-bootstrap';
import { getEventWorkbooksApi, createEventWorkBookApi, deleteEventWorkBookApi } from '../../../api/events';

export const EventWorkbooks = ({ eventId, communityId, isOwner }) => {
  const [workbooks, setWorkbooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({ title: '', file: null });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (eventId) fetchWorkbooks();
  }, [eventId]);

  const fetchWorkbooks = async () => {
    try {
      setLoading(true);
      const res = await getEventWorkbooksApi({ eventId });
      setWorkbooks(res.data || []);
    } catch (err) {
      console.warn('Failed to fetch workbooks', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this workbook?')) return;
    try {
      await deleteEventWorkBookApi(id);
      fetchWorkbooks();
    } catch (err) {
      alert('Failed to delete workbook.');
    }
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    if (!formData.title || !formData.file) {
      alert('Please provide title and file');
      return;
    }
    try {
      setSubmitting(true);
      const fd = new FormData();
      fd.append('community', communityId);
      fd.append('event', eventId);
      fd.append('fileTitles', JSON.stringify([formData.title]));
      fd.append('workbooks', formData.file);
      await createEventWorkBookApi(fd);
      setShowAddForm(false);
      setFormData({ title: '', file: null });
      fetchWorkbooks();
    } catch (err) {
      alert('Failed to add workbook.');
    } finally {
      setSubmitting(false);
    }
  };

  if (showAddForm) {
    return (
      <div className="bg-light p-3 rounded-4 border">
        <h6 className="fw-bold mb-3">Add New Workbook</h6>
        <Form onSubmit={handleAddSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Workbook title"
              value={formData.title}
              onChange={e => setFormData({ ...formData, title: e.target.value })}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Workbook File (PDF only)</Form.Label>
            <Form.Control
              type="file"
              accept="application/pdf"
              onChange={e => setFormData({ ...formData, file: e.target.files[0] })}
              required
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="light" className="rounded-pill" onClick={() => setShowAddForm(false)}>Cancel</Button>
            <Button variant="primary" type="submit" disabled={submitting} className="rounded-pill px-4 cd-btn-orange border-0">
              {submitting ? 'Uploading...' : 'Upload'}
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  return (
    <div>
      {isOwner && (
        <div className="d-flex justify-content-end mb-3">
          <Button variant="primary" className="rounded-pill px-4 cd-btn-orange border-0" onClick={() => setShowAddForm(true)}>
            <i className="bi bi-plus-lg me-1"></i> Add Workbook
          </Button>
        </div>
      )}

      {loading ? (
        <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>
      ) : workbooks.length === 0 ? (
        <div className="text-center py-5">
          <i className="bi bi-book text-muted" style={{ fontSize: '3rem' }}></i>
          <h5 className="mt-3">No Workbooks</h5>
          <p className="text-muted">No workbooks have been added yet.</p>
        </div>
      ) : (
        <Row className="g-3">
          {workbooks.map((item) => (
            <Col md={6} key={item._id}>
              <div className="card h-100 border-0 shadow-sm rounded-4 position-relative">
                {isOwner && (
                  <button
                    className="btn btn-sm btn-danger position-absolute top-0 end-0 m-2 rounded-circle shadow-sm"
                    onClick={() => handleDelete(item._id)}
                    title="Delete Workbook"
                    style={{ zIndex: 2 }}
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                )}
                <div className="card-body text-center p-4">
                  <i className="bi bi-file-earmark-pdf-fill text-primary" style={{ fontSize: '2.5rem' }}></i>
                  <h6 className="mt-3 mb-1 fw-bold text-truncate">{item.title}</h6>
                  {item.createdAt && <small className="text-muted d-block mb-3">{new Date(item.createdAt).toLocaleDateString()}</small>}
                  {item.url && (
                    <a href={item.url} target="_blank" rel="noreferrer" className="btn btn-outline-primary btn-sm rounded-pill px-3 mt-auto">
                      Download
                    </a>
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};
